import { AWAITING_REPLY, NO_QUOTE } from "MODULES/IncomingQuotes/constants";
import { COST, EMAIL, LINE_ITEMS, NAME, QUANTITY } from "APP_ROOT/constants";
import * as rules from "LIB/validation/rules";
import { CONDITION } from "MODULES/inventories/constants";
import { validator } from "LIB/validate-this";

export function validateLineItem(lineItem, values, fieldPrefix = null) {
  const quoteType = fieldPrefix
    ? values[fieldPrefix].quote_type
    : values.quote_type;

  if (![NO_QUOTE, AWAITING_REPLY].includes(quoteType)) return;

  if (quoteType !== NO_QUOTE) {
    lineItem.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    lineItem.validate(COST, CONDITION, QUANTITY).satisfies(rules.required);
    lineItem.validate(COST).satisfies(rules.isGreaterThanOrEqualTo(0));
  }
}

export default function validate(values) {
  return validator(values, form => {
    form.validate(NAME, EMAIL).satisfies(rules.required);
    form.validate(EMAIL).satisfies(rules.isValidEmail);
    form.validateChildren(LINE_ITEMS, validateLineItem);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Customers/IncomingQuote/validate.js